/**
 * Component for AdBlockerMessage
 *
 * @module components/AdBlockerMessage
 */

import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import ButtonT3 from '../../../../components/lib/ButtonT3/ButtonT3';
import { ButtonT3Size, ButtonT3Theme } from '../../../../components/lib/ButtonT3/constants';
import QA from '../../../../constants/QATags';
import MiniHeader from '../../MiniHeader/MiniHeader';

import './AdBlockerMessageBar.scss';

class AdBlockerMessageBar extends React.Component {
  static propTypes = {
    onClose: PropTypes.func,
    handleClick: PropTypes.func,
    message: PropTypes.object,
    buttonText: PropTypes.object,
    buttonLink: PropTypes.string,
  };

  renderButton() {
    const { buttonLink, buttonText, handleClick } = this.props;
    if (!(buttonText || buttonLink)) {
      return;
    }

    return (
      <ButtonT3
        size={ButtonT3Size.SMALL}
        theme={ButtonT3Theme.WHITE}
        href={buttonLink}
        onClick={handleClick}
        isExternalLink={true}
        isTargetBlank={true}
      >
        <FormattedMessage {...buttonText} />
      </ButtonT3>
    );
  }

  render() {
    return (
      <MiniHeader showing={true} onClose={this.props.onClose}>
        <div className='AdBlockerMessageBar' data-qa={QA.MB}>
          <FormattedMessage {...this.props.message} />
          {this.renderButton()}
        </div>
      </MiniHeader>
    );
  }
}

export default AdBlockerMessageBar;
